import { STATSIG_ENVIRONEMNTS } from "@services/statsig.service";

export const STATSIG_OVERRIDES_KEY = 'statsig-all-overrides';

export interface IStatsigOverrides {
  gate: Record<string, boolean>;
  dynamicConfig: Record<string, string>;
  statsigEnvironmentSelected?: STATSIG_ENVIRONEMNTS;
  ishighlighterEnabled: boolean;
};

export interface IHighlighterData {
  flagKey: string;
  xPath: string;
};

export type HighlighterMap = Record<string, IHighlighterData[]>;

export const statsigOverlayChevronDownIcon: string = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
  xmlns="http://www.w3.org/2000/svg"><path d="M5.44199 8.04248L4.55811 8.92637L9.38184 13.7501H10.6183L15.442
  8.92637L14.5581 8.04248L10.0001 12.6005L5.44199 8.04248Z" fill="black"/></svg>`;
